import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import Typography from 'components/CncUI/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    [breakpoints.down('sm')]: {
      maxWidth: 248,
    },
  },
  image: {
    width: 63,
    height: 63,
    alignSelf: 'center',
  },
  small: {
    justifyContent: 'center',
    '& div:first-of-type': {
      width: 57,
      height: 57,
    },
    '& .MuiCardContent-root:last-child': {
      paddingBottom: 0,
    },
    [breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  okta: {
    justifyContent: 'center',
    '& div:first-of-type': {
      width: 64,
      height: 63,
    },
    '& .MuiCardContent-root:last-child': {
      paddingBottom: 0,
    },
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%',
    },
  },
  content: {
    width: 274,
    height: 80,
    textAlign: 'left',
    padding: '8px 12px',
    [breakpoints.down('sm')]: {
      width: '65%',
    },
  },
  oktaContent: {
    [breakpoints.down('sm')]: {
      width: '75%',
    },
  },
  auto: {
    height: 'auto',
    '& p': {
      color: `${palette.cncUI.primary.gray.primary} !important`,
    },
  },
  title: {
    fontWeight: 500,
    color: '#898989 !important',
    lineHeight: '20px',
    marginBottom: 0,
  },
  text: {
    fontWeight: 400,
    color: '#7e7e7e !important',
    lineHeight: '16px',
    margin: '2px 0',
  },
  extra: {
    fontSize: 10,
    color: '#898989 !important',
    lineHeight: '16px',
    fontStyle: 'italic',
    margin: 0,
  },
}));

const PhoneVerificationCard = props => {
  const classes = useStyles();
  const { image = '', title = '', text = '', extra = '', variant } = props;
  return (
    <Card className={clsx(classes.root, variant && classes[variant])}>
      <CardMedia className={classes.image} image={image} />
      <CardContent
        className={clsx(
          classes.content,
          variant && classes.auto,
          variant === 'okta' && classes.oktaContent,
        )}
      >
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body1" className={classes.text}>
          {text}
        </Typography>
        <Typography variant="microcaption" className={classes.extra}>
          {extra}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default PhoneVerificationCard;
